import { config } from '@iheartjane/config';
import { googleMapsLoader } from '@iheartjane/geolocation';

export const getGoogleMaps = () => googleMapsLoader(config.googlePlacesKey);
